<script>
/*
- 通用素材选择弹窗组件，如需定制modal，可参考index.js只导出AssetsSelector
- 传入的attrs会被当成props再次传入Selector
*/
import Selector from './selector.vue'
export default {
  components: { Selector },
  props: {
    visible: {
      type: Boolean
    },
    title: {
      type: String,
      default: '素材选择'
    },
    width: {
      type: String,
      default: '1200px'
    }
  },
  render(createElement) {
    const scopedSlots = {
      assetType: (slotProps) => createElement('slot', {}, this.$scopedSlots.assetType({ getData: slotProps.getData }))
    }
    if (this.$scopedSlots.materialAnalysis) {
      scopedSlots.materialAnalysis = (slotProps) =>
        createElement(
          'slot',
          {},
          this.$scopedSlots.materialAnalysis({
            loading: slotProps.loading,
            analysisInfo: slotProps.analysisInfo,
            select: slotProps.select,
            update: slotProps.update
          })
        )
    }
    if (this.$scopedSlots.sizes) {
      scopedSlots.sizes = (slotProps) => createElement('slot', {}, this.$scopedSlots.sizes({ getData: slotProps.getData }))
    }

    if (this.$scopedSlots.mediatag) {
      scopedSlots.mediatag = (slotProps) => createElement('slot', {}, this.$scopedSlots.mediatag({ getData: slotProps.getData }))
    }
    const h = createElement(
      'el-dialog',
      {
        props: {
          customClass: 'material-selector-dialog',
          title: this.title,
          width: this.width,
          visible: this.visible,
          // showClose: false,
          appendToBody: true,
          closeOnClickModal: false
        },
        on: this.$listeners
      },
      [
        createElement(Selector, {
          props: { ...this.$attrs, visible: this.visible },
          on: this.$listeners,
          /*
            渲染函数插槽 https://v2.cn.vuejs.org/v2/guide/render-function.html#%E6%8F%92%E6%A7%BD
            slot传递
          */
          scopedSlots
        })
      ]
    )

    return h
  }
}
</script>
